<template>
  <div class="accountList" :style="{ margin }">
    <div @click="onEditAccount(null)" class="accountList_title">
      <span>Zelle accounting</span>
	    <v-btn
			    v-if="!hideBtn"
			    icon
			    color="green"
			    class="deleteBtn"
			    type="button"
	    >
		    <svg-sprite width="20" height="20" icon-id="plus"></svg-sprite>
	    </v-btn>
    </div>
    <div
        class="accountList_item"
        v-for="(item, idx) in list"
        :key="item.id"
    >
      <field
          margin="10px 0 10px 0"
          width="370px"
          label="Account"
          :setInputValue="item.account"
          is-readonly
      ></field>
	    <v-btn
			    v-if="!hideBtn"
			    icon
			    color="green"
			    class="accountList_button"
			    type="button"
			    @click="onEditAccount(item)"
	    >
		    <svg-sprite width="20" height="20" icon-id="edit"></svg-sprite>
	    </v-btn>
	    <v-btn
			    v-if="!hideBtn && listLength"
			    icon
			    color="green"
			    class="accountList_button"
			    type="button"
			    @click="onRemoveAccount(idx)"
	    >
		    <svg-sprite width="20" height="20" icon-id="deleteItem"></svg-sprite>
	    </v-btn>
    </div>
  </div>
</template>

<script>
export default {
	name: "AccountList",
	props: {
		list: Array,
		hideBtn: Boolean,
		margin: {
			type: String,
			default: () => '0'
		}
	},
	computed: {
		listLength() {
			return this.list.length > 1;
		}
	},
	methods: {
		onEditAccount(value) {
			this.$emit('updateAccountEdit', value);
		},
		onRemoveAccount(value) {
			this.$emit('updateAccountRemove', value);
		}
	}
};
</script>

<style scoped lang="scss">
.accountList {
  &_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: var(--card-color-sub-title);
  }

  &_item {
	  gap: 5px;
    display: flex;
	  align-items: center;
	  justify-content: space-between;
  }
}
</style>
